import { render, staticRenderFns } from "./IndicatorsComponent.vue?vue&type=template&id=304320a2&scoped=true&"
import script from "./IndicatorsComponent.vue?vue&type=script&lang=js&"
export * from "./IndicatorsComponent.vue?vue&type=script&lang=js&"
import style0 from "./IndicatorsComponent.vue?vue&type=style&index=0&id=304320a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "304320a2",
  null
  
)

export default component.exports